const createMediaQueryRange = (min, max, styles = {}) => {
  return {
    [`@media (min-width: ${min}px) and (max-width: ${max}px)`]: styles
  };
};
export {
  createMediaQueryRange
};
//# sourceMappingURL=createMediaQueryRange.js.map
